import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material';
import { storePcoToken } from './usePcoAuthUser';
import { congregantPortalPath, congregantPortalLoginPath } from '../../constants';

/**
 * Landing page for the redirect back from Planning Center. The backend
 * puts the session token in the URL fragment (see
 * authController.pcoCallback) rather than a query string, so it's never
 * sent to any server on the next request and never lands in a Referer
 * header or server log - only this page ever reads it, and only to move
 * it into localStorage.
 */
const PcoCallback = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    const hash = new URLSearchParams(window.location.hash.slice(1));
    const token = hash.get('token');
    const oauthError = hash.get('error');

    if (token) {
      storePcoToken(token);
      navigate(congregantPortalPath, { replace: true });
      return;
    }

    setError(oauthError || 'login_failed');
  }, [navigate]);

  if (!error) {
    return <div></div>;
  }

  return (
    <div
      style={{
        paddingTop: 'var(--nav-height)',
        minHeight: '100vh',
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '12px',
        fontFamily: theme.typography.paragraphFontFamily,
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.brand.linen,
        textAlign: 'center',
        padding: '48px 24px',
      }}
    >
      <p>Something went wrong signing in with Planning Center ({error}).</p>
      <a href={congregantPortalLoginPath} style={{ color: theme.palette.primary.main, fontWeight: 600 }}>
        Try again
      </a>
    </div>
  );
};

export default PcoCallback;
